/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://hhy6uiv2nvbmvkbo3q35w7z5xm.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-4qppdaoydvchvej5if2hlbyzzq",
    "aws_cognito_identity_pool_id": "us-east-1:3bf60da5-0afc-4886-95b8-4f6119ee0194",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_VUQ4SrcN7",
    "aws_user_pools_web_client_id": "4v2u8colglk1m41sa63c0bofvu",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "collectionmapf9fe0-production",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
